import { render, staticRenderFns } from "./player.vue?vue&type=template&id=6f88e96f"
import script from "./player.vue?vue&type=script&lang=js"
export * from "./player.vue?vue&type=script&lang=js"
import style0 from "./player.vue?vue&type=style&index=0&id=6f88e96f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports